import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { reduxForm } from 'redux-form'
import JSZip from 'jszip'

import shortid from 'shortid';
import {CopyToClipboard} from 'react-copy-to-clipboard';

import './ToolTray.css';


import Checkbox from '../Checkbox/Checkbox.js'
import CustomField from '../CustomField/CustomField.js'
import Button from '../Button/Button.js'
import PatternThumbnail from '../PatternThumbnail/PatternThumbnail.js'
import Tabs from '../Tabs/Tabs.js'

import generateName from '../../pattern_utilities/generateName.js'
import generateFullDownloadableText from '../../pattern_utilities/generateFullDownloadableText.js'
import patternWatermark from '../../pattern_utilities/patternWatermark.js'

import { 
  tryToGetTeamPatterns, 
  tryToGetMyPatterns, 
  setTrayOpen, 
  tryToGetOfficialPatterns,
  showTooltip,
  hideTooltip,
  showLockedFeatureModal
} from '../../actions/actions.export.js';

import canI from '../../canI.js';


const default_filters = [
  { value: "AUTOCAD", checked: false },
  { value: "REVIT", checked: false },
  { value: "INCH", checked: false },
  { value: "MM", checked: false },
  { value: "DRAFTING", checked: false },
  { value: "MODEL", checked: false },
  { value: "PUBLIC", checked: false },
  { value: "PRIVATE", checked: false },
  { value: "BAKED", checked: false },
  { value: "DRAWING", checked: false },
  { value: "TEMPLATE", checked: false },
  { value: null, divider: true }
];


const paginate_size = 40;

class ToolSavedTray extends Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired
  }

  constructor(props){
    super(props);

    this.state = {
      view: {
        display: "My Patterns",
        value: 'myPatterns'
      },
      searchMyPatterns: '',
      andOrMyPatterns: 'AND',
      filters: JSON.parse(JSON.stringify(default_filters)),
      lastScope: undefined,
      sortMethod: 'time',
      amount_to_show: paginate_size
    }

    this.toggleFilter = this.toggleFilter.bind(this);
    this.escFunction = this.escFunction.bind(this);
    this.handleDownloadZip = this.handleDownloadZip.bind(this);
    this.handleMultiFileDownload = this.handleMultiFileDownload.bind(this);
  }

  escFunction(event){
    const { dispatch, globalReducer } = this.props;
    if(event.keyCode === 27 && globalReducer.trayOpen.saved){
      dispatch(setTrayOpen({tray: "saved", open: false} ))
      this.setState({amount_to_show: paginate_size});
    }
  }
  componentDidMount(){
    document.addEventListener("keydown", this.escFunction, false);
  }
  componentWillUnmount(){
    document.removeEventListener("keydown", this.escFunction, false);
  }

  toggleFilter(index, filters){
    // var filters = this.state.filters;
    filters[index].checked = !filters[index].checked;

    if(filters[index].checked){
      var elem = document.getElementById('saved-tray');
      elem.scrollTop = 0;
    }

    this.setState({
      filters: filters,
      amount_to_show: paginate_size
    })
  }

  componentWillReceiveProps(newprops){
    const { globalReducer, dispatch } = this.props;
    const { team, user, patternManager } = newprops;

    var thisScope = user.id;
    if(team.current && team.cache[team.current]){
      thisScope = team.cache[team.current].id;
    }

    // console.log(newprops.globalReducer.trayOpen.saved, globalReducer.trayOpen.saved);
    if(!newprops.globalReducer.trayOpen.saved && this.state.amount_to_show > paginate_size){
      this.setState({amount_to_show: paginate_size});
    }

    if(thisScope !== this.state.lastScope){
      this.setState({
        filters: JSON.parse(JSON.stringify(default_filters)),
        lastScope: thisScope,
        amount_to_show: paginate_size
      })
    }

    // these two fire off if the tray opens and there arent any patterns to be found
    let now = new Date().getTime();
    if(thisScope === user.id){
      if(globalReducer.trayOpen.saved && patternManager.myPatterns.length === 0 && !patternManager.tryingToGetMyPatterns && now - patternManager.successfullyGotMyPatterns > 10000){
        dispatch(tryToGetMyPatterns());
      }
    } else {
      if(globalReducer.trayOpen.saved && patternManager.teamPatterns[thisScope] === undefined && !patternManager.tryingToGetTeamPatterns && now - patternManager.successfullyGotTeamPatterns > 10000){
        dispatch(tryToGetTeamPatterns({
          id: thisScope
        }));
      }
    }
  }

  handleDownloadZip(patterns){
    const { patternManager, user, team } = this.props;

    function download(data, filename, type) {
      var file = new Blob([data], {type: type});
      var a = document.createElement("a");
      var url = URL.createObjectURL(file);
      a.href = url;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      setTimeout(function() {
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);  
      }, 0); 
    }

    var zip = new JSZip();
    var patternsFolder = zip.folder("Pattycake Patterns");
    for(var i in patterns){
      let p = patternManager.cache[patterns[i]];
      let text = generateFullDownloadableText(p, user, team.cache[team.current], true, true, true, false);
      patternsFolder.file(generateName(p) + ".pat", text);
    }
    zip.generateAsync({type:"blob"})
    .then(function(content) {
        // see FileSaver.js
        download(content, "Pattycake_Patterns.zip", "zip");
    });
  }


  handleMultiFileDownload(patterns){
    const { patternManager, user, team } = this.props;

    function download(data, filename, type) {
      var file = new Blob([data], {type: type});
      var a = document.createElement("a");
      var url = URL.createObjectURL(file);
      a.href = url;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      setTimeout(function() {
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);  
      }, 0); 
    }

    let text = "";
    if(team.current && team.cache[team.current] && team.cache[team.current].signature){
      
      var sig_lines = team.cache[team.current].signature.split(/[\r\n]/);
      for(var i in sig_lines){
        text += '; ' + sig_lines[i] + '\r\n';
      }

    } else {
      text += patternWatermark;
    }

    for(var i in patterns){
      let p = patternManager.cache[patterns[i]];
      text += "\n\n\n\n";
      text += p.text
    }
    
    download(text, "Pattycake_Pattern_Multifile.pat", "pat");
    
  }


  render(){
    const { user, dispatch, globalReducer, patternManager, cacheID, team} = this.props;
    const that = this;

    var patterns = patternManager.myPatterns;
    if(team.current && team.cache[team.current]){
      patterns = patternManager.teamPatterns[team.cache[team.current].id] || [];
    }

    var patternTags = {};
    for(var i in patterns){
      var p = patternManager.pristineCache[patterns[i]];
      patternTags[patterns[i]] = [];
      patternTags[patterns[i]].push(p.format);
      patternTags[patterns[i]].push(p.units);
      patternTags[patterns[i]].push(p.type);
      patternTags[patterns[i]].push(p.private ? 'PRIVATE' : 'PUBLIC');
      if(p.mode === 'template'){
        patternTags[patterns[i]].push('TEMPLATE');
      }
      if(p.mode === 'raster'){
        patternTags[patterns[i]].push('BAKED');
      }
      if(p.mode === 'drawing'){
        patternTags[patterns[i]].push('DRAWING');
      }
      for(var j in p.projects){
        patternTags[patterns[i]].push(p.projects[j]); 
      }
    }


    var filters = this.state.filters;
    
    var project_filters = [];
    for(var i in patterns){
      var p = patternManager.pristineCache[patterns[i]];
      for(var t in p.projects){
        var found = false;
        for(var f in project_filters){
          if(project_filters[f].value == p.projects[t]){
            found = true;
            break;
          }
        }

        if(!found) project_filters.push({value: p.projects[t], checked: false, project: true});
      }
    }

    project_filters.sort((a,b)=>{
      if(a.value > b.value) return 1;
      if(a.value < b.value) return -1;
      return 0;
    })

    for(var i in project_filters){
      var found = false;
      for(var j in filters){
        if(filters[j].project && filters[j].value === project_filters[i].value){
          found = true;
          break;
        }
      }
      if(!found) filters.push(project_filters[i]);
    }


    for(var i in filters){
      filters[i].count = 0;
      for(var j in patternTags){
        if(patternTags[j].indexOf(filters[i].value) > -1){
          filters[i].count++;
        }
      }
    }

    var filtersChecked = [];
    for(var i in filters){
      if(filters[i].checked){
        filtersChecked.push(filters[i].value);
      }
    }

    var filteredPatterns = [];
    for(var i = 0; i < patterns.length; i++){
      var p = patterns[i];
      if(filtersChecked.length > 0){
        if(this.state.andOrMyPatterns === 'AND'){
          var match = true;
          for(var j in filtersChecked){
            if(patternTags[p].indexOf(filtersChecked[j]) === -1){
              match = false; 
              break;
            }
          }
          if(!match) continue;
        } else {
          var match = false;
          for(var j in filtersChecked){
            if(patternTags[p].indexOf(filtersChecked[j]) > -1){
              match = true; 
              break;
            }
          }
          if(!match) continue;
        }
      }

      if(this.state.searchMyPatterns !== ''){
        if((generateName(patternManager.pristineCache[p]) + ' ' + (patternManager.pristineCache[p].tags || []).join(' ') + ' ' + (patternManager.pristineCache[p].created_by_name ? patternManager.pristineCache[p].created_by_name : '')).toLowerCase().indexOf(that.state.searchMyPatterns.toLowerCase()) > -1){
          // return thumbnail;
          filteredPatterns.push(p);
          continue;
        }
        continue;
      } else {
        // return thumbnail;
        filteredPatterns.push(p);
        continue;        
      }

      filteredPatterns.push(p);
    }


    if(filtersChecked.length > 0){
      for(var i = 0; i < filters.length; i++){
        filters[i].count = 0;
        for(var j in filteredPatterns){
          if(patternTags[filteredPatterns[j]].indexOf(filters[i].value) > -1){
            filters[i].count++;
          }
        }
      }
    } 


    if(this.state.sortMethod === 'time'){
      filteredPatterns.sort(function(a,b){
        if(patternManager.pristineCache[a].updated_on > patternManager.pristineCache[b].updated_on) return -1;
        if(patternManager.pristineCache[a].updated_on < patternManager.pristineCache[b].updated_on) return 1;
        return 0;
      });
    } else if(this.state.sortMethod === 'alphabetical'){
      filteredPatterns.sort(function(a,b){
        if(patternManager.pristineCache[a].name.toLowerCase() > patternManager.pristineCache[b].name.toLowerCase()) return 1;
        if(patternManager.pristineCache[a].name.toLowerCase() < patternManager.pristineCache[b].name.toLowerCase()) return -1;
        return 0;
      });
    } else if(this.state.sortMethod === 'downloads'){
      filteredPatterns.sort(function(a,b){
        let ad = patternManager.pristineCache[a].stats ? patternManager.pristineCache[a].stats.downloads || 0 : 0;
        let bd = patternManager.pristineCache[b].stats ? patternManager.pristineCache[b].stats.downloads || 0 : 0;
        if(ad > bd) return -1;
        if(ad < bd) return 1;
        return 0;
      });
    }

    var trimmed_patterns = filteredPatterns.slice(0, this.state.amount_to_show);

    return <div id="saved-tray" className={"tool-pattern-tray " + (globalReducer.trayOpen.saved ? "tool-pattern-tray-open" : "")}>
      <span 
        className="clickable exit-button" 
        onClick={(e)=>{ 
          dispatch(setTrayOpen({tray: "saved", open: false} ));
          this.setState({amount_to_show: paginate_size});
        }}>
        <i className="fal fa-times fa-3x"/>
      </span>
      <div className="container-fluid">

        <div className="row row-push-down">
          <div className="col-md-12">
           
          </div>
        </div>

        {
          this.state.view.value === 'myPatterns' && 
          <div className="row">
            <div className="col-md-2">
             <Tabs
                items={[
                    {
                      display: 'AND',
                      value: 'AND'
                    },
                    {
                      display: 'OR',
                      value: 'OR'
                    }
                  ]}
                value={this.state.andOrMyPatterns}
                size='small'
                onChange={(e) => { this.setState({ andOrMyPatterns: e.value }) }}
                /> 
              <hr/>
              <h5>Filters</h5> 
              {
                filters.map((f, i)=>{

                  if(f.divider && !team.current) return;

                  if(f.project && !team.current) return;

                  return <div key={i} className="text-ellipsis">
                    {
                      f.divider ? <div>
                        <hr/> 
                        <h5>Projects</h5>
                      </div>
                      :
                      <nobr>
                        <Checkbox value={f.checked} onToggle={(e)=>{ this.toggleFilter(i, filters)}}/> 
                        <strong className="filter-text">
                          {f.value} <small className={"text-800 " + (f.count > 0 ? "text-secondary" : "translucent")}>{f.count}</small>
                        </strong>
                      </nobr>
                    }
                  </div>
                })
              }
              
            </div>
            <div className="col-md-10">
              {/*<div className="row"> 
                <div className="col-md-12">
                  <h5>Search</h5>
                </div>
              </div>
              */}
              <div className="row row-padded"> 
                <div className="col-md-12">
                  <CustomField
                    name="searchMyPatterns"
                    type='text'
                    placeholder='search your patterns by name or tags...'
                    inline={true}
                    onChange={(e)=> { 
                      that.setState({
                        searchMyPatterns: e,
                        amount_to_show: 20
                      }) 
                    }}
                    form={false}
                    />
                </div>
              </div>
              <div className="row">
                <div className="col-md-12"> 
                  <div className="list-left">
                    <Button
                      display={<span>Download Zip {!canI(user, team, "bulkZipDownload", team.current) && <span> <i className="fad text-award fa-award"/></span>}</span>}
                      onClick={() => {
                        if(canI(user, team, "bulkZipDownload", team.current)){
                          this.handleDownloadZip(filteredPatterns)
                          } else {
                          dispatch(showLockedFeatureModal("bulkZipDownload"));
                        }
                      }}
                      onMouseEnter={(e)=>{ 
                        dispatch(showTooltip({
                          e: e,
                          position: 'bottom', 
                          lag: 100,
                          nobr: false,
                          content: <div style={{width: 200}}>
                            Download your current filter selection of {filteredPatterns.length} pattern{filteredPatterns.length !== 1 && "s"} as a zip file. 
                          </div>
                        }))
                      }} 
                      onMouseLeave={(e)=>{ dispatch(hideTooltip()) }}
                    />
                  {/*
                    <Button
                      display={<span>Download Multifile {!canI(user, team, "bulkMultiDownload", team.current) && <span> <i className="fad text-award fa-award"/></span>}</span>}
                      disabled={filteredPatterns.length < 2}
                      onClick={() => {
                        if(canI(user, team, "bulkMultiDownload", team.current)){
                          this.handleMultiFileDownload(filteredPatterns)
                        } else {
                          dispatch(showLockedFeatureModal("bulkMultiDownload"));
                        }
                      }}
                      onMouseEnter={(e)=>{ 
                        dispatch(showTooltip({
                          e: e,
                          position: 'bottom', 
                          lag: 100,
                          nobr: false,
                          content: <div style={{width: 200}}>
                            Download your current filter selection of {filteredPatterns.length} pattern{filteredPatterns.length !== 1 && "s"} as a single file combination for Revit import.
                          </div>
                        }))
                      }} 
                      onMouseLeave={(e)=>{ dispatch(hideTooltip()) }}
                    />
                    */}

                    <div className="list-item">
                      <Tabs
                        items={[
                            {
                              display: <i className="fas fa-font-case"/>,
                              value: 'alphabetical'
                            },
                            {
                              display: <i className="fas fa-clock"/>,
                              value: 'time'
                            },
                            {
                              display: <i className="fas fa-download"/>,
                              value: 'downloads'
                            }
                          ]}
                        value={this.state.sortMethod}
                        size='small'
                        onChange={(e) => { this.setState({ sortMethod: e.value }) }}
                        /> 
                    </div>
                    {
                      patterns.length == filteredPatterns.length ?
                      <div className="list-item">
                        Showing all {patterns.length} pattern{patterns.length !== 1 && "s"} 
                      </div> 
                      :
                      <div className="list-item">
                        Filtered to {filteredPatterns.length} of {patterns.length} pattern{patterns.length !== 1 && "s"} 
                      </div>
                    }


                    <div className="list-item">
                      {
                        filters.map((f, i)=>{
                          if(!f.checked) return
                          return <span className="filter-pill" onClick={(e)=>{ this.toggleFilter(i, filters); }} key={i}>
                            {f.value} <i className="fal fa-times"/>
                          </span>
                        })
                      }
                    </div>

                    {
                      (patternManager.tryingToGetMyPatterns || patternManager.tryingToGetTeamPatterns) && 
                      <span className="text-muted list-item">
                        <i className="far fa-spinner-third fa-spin fa-fw fa-lg"/> Loading...
                      </span>
                    }

                  </div>
                  <hr/>
                </div>
              </div>
              <div className="row row-push-down-extra">
              { trimmed_patterns.map(function(p, i){
                  return <div key={i} className="col-lg-3 col-md-4 col-sm-6">
                    <PatternThumbnail 
                      cacheID={p} 
                      light={true} 
                      onClick={(e)=> { 
                        if((patternManager.cache[patternManager.current_pattern].unsavedChanges || patternManager.tryingToUpdatePattern || patternManager.tryingToCreateNewPattern)){
                          // unsaved changes modal will catch here
                        } else {
                          dispatch(setTrayOpen({tray: "saved", open: false}));
                        }
                      }}
                      />
                  </div>
                })
              }
              {
                (filteredPatterns.length === 0) && <div className="col-md-12">
                  <p className="text-lg">
                    <i className="fal fa-frown fa-fw fa-lg"/> You don't have any patterns that match the current search and filters.
                  </p>
                </div>
              }
              {
                (filteredPatterns.length > trimmed_patterns.length) && <div className="col-md-12">
                  <div className="list-center">
                    <Button
                      display="Show More"
                      color="grey"
                      size="medium"
                      onClick={(e)=>{this.setState({
                        amount_to_show: this.state.amount_to_show + paginate_size
                      })}}
                    />
                  </div>
                </div>
              }
              </div>
            </div>
          </div>
        }
      </div>
    </div>
  }
}

const mapStateToProps = (state) => {
  const { 
    globalReducer, patternManager, user, team
    //...
  } = state;

  return {
    globalReducer, patternManager, user, team
    //...
  }
}

export default connect(mapStateToProps)(ToolSavedTray);



// WEBPACK FOOTER //
// ./src/components/ToolTrays/ToolSavedTray.js